import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

function AdminRedirect() {
  const navigate = useNavigate();

  useEffect(() => {
    // Check if user has token
    const token = localStorage.getItem('admin_token');
    
    if (token) {
      // If token exists, go to dashboard
      navigate('/admin/dashboard');
    } else {
      // Otherwise, go to login
      navigate('/admin/login');
    }
  }, [navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center">
      <p>Redirecting...</p>
    </div>
  );
}

export default AdminRedirect;
